import React from 'react'

type Props = {
  className: string
  description: string
  color: string
  img: string
}

const CardsWidget20 = ({className, description, color, img}: Props) => {
  const totalAnnouncedFunding = 6704048621
  const totalAwardedFunding = 1259817990

  // Calculate the percentage of awarded funds
  const percentageAwarded = Math.round((totalAwardedFunding / totalAnnouncedFunding) * 100)

  return (
    <div
      className={`card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end ${className}`}
      style={{
        backgroundColor: color,
        backgroundImage: `url('${img}')`,
      }}
    >
      <div className='card-header pt-5'>
        <div className='card-title d-flex flex-column'>
          <div className='d-flex align-items-center'>
            <span className='fs-4 fw-semibold text-gray-400 me-1 align-self-start'>$</span>
            <span className='fs-1 fw-bold text-white me-2 lh-1 ls-n2'>
              {totalAwardedFunding.toLocaleString()}
            </span>
          </div>
          <span className='text-white opacity-75 pt-1 fw-semibold fs-6'>Total Awarded Funding</span>
          <br />
          <div className='d-flex align-items-center'>
            <span className='fs-4 fw-semibold me-1 align-self-start' style={{color: '#3DD6D0'}}>
              $
            </span>
            <span className='fs-1 fw-bold me-2 lh-1 ls-n2' style={{color: '#3DD6D0'}}>
              {totalAnnouncedFunding.toLocaleString()}
            </span>
          </div>

          <span className='fw-semibold fs-6' style={{color: '#3DD6D0'}}>
            Total Announced Funding*
          </span>
        </div>
      </div>
      <div className='card-body d-flex align-items-end pt-0'>
        <div className='d-flex align-items-center flex-column mt-3 w-100'>
          <div className='d-flex justify-content-between fw-bold fs-6 text-white opacity-75 w-100 mt-auto mb-2'>
            <span>Percent Awarded</span>
            <span>{percentageAwarded}%</span>
          </div>
          <div className='h-8px mx-3 w-100 bg-white bg-opacity-50 rounded'>
            <div
              className='bg-white rounded h-8px'
              role='progressbar'
              style={{width: `${percentageAwarded}%`}}
              aria-valuenow={percentageAwarded}
              aria-valuemin={0}
              aria-valuemax={100}
            ></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {CardsWidget20}
